import * as images from './menuItemsImages'
import { menuItemToLink } from './menuItemToLink'

export const menus = [
  {
    name: 'assetManagement',
    title: 'Asset Management',
    menus: [
      {
        level: 0,
        name: 'resources',
        linkTo: menuItemToLink['resources'] || undefined,
        text: 'Entities',
        image: images.Resources
      },
      {
        level: 0,
        name: 'accounts',
        linkTo: menuItemToLink['accounts'] || undefined,
        text: 'Accounts',
        image: images.Accounts
      },
      {
        level: 0,
        name: 'assets',
        linkTo: menuItemToLink['none'] || undefined,
        text: 'Buildings + Locations',
        image: images.Locations,
        subMenus: [
          {
            level: 1,
            name: 'multiTenantBuildings',
            linkTo: menuItemToLink['multiTenantBuildings'] || undefined,
            text: 'Multi-Tenant Buildings',
            image: images.MultiTenantBuildings
          },
          {
            level: 1,
            name: 'locations',
            linkTo: menuItemToLink['locations'] || undefined,
            text: 'Locations',
            image: images.Locations
          }
        ]
      },
      {
        level: 0,
        name: 'people',
        linkTo: menuItemToLink['none'] || undefined,
        text: 'People',
        image: images.People,
        subMenus: [
          {
            level: 1,
            name: 'users',
            linkTo: menuItemToLink['users'] || undefined,
            text: 'Users',
            image: images.Users
          },
          {
            level: 1,
            name: 'contacts',
            linkTo: menuItemToLink['contacts'] || undefined,
            text: 'Contacts',
            image: images.Contacts
          }
        ]
      },
      {
        level: 0,
        name: 'services',
        linkTo: menuItemToLink['services'] || undefined,
        text: 'Services',
        image: images.Services
      },
      {
        level: 0,
        name: 'skillSets',
        linkTo: menuItemToLink['skillSets'] || undefined,
        text: 'Skill Sets',
        image: images.SkillSets
      }
    ]
  },
  {
    name: 'groupManagement',
    title: 'Group Management',
    menus: [
      {
        level: 0,
        name: 'accessManagement',
        linkTo: menuItemToLink['none'] || undefined,
        text: 'Access Management',
        image: images.AccessManagement,
        subMenus: [
          {
            level: 1,
            name: 'operationalGroups',
            linkTo: menuItemToLink['operationalGroups'] || undefined,
            text: 'Operational Groups',
            image: images.OperationalGroups
          },
          {
            level: 1,
            name: 'userGroups',
            linkTo: menuItemToLink['userGroups'] || undefined,
            text: 'User Groups',
            image: images.UserGroups
          },
          {
            level: 1,
            name: 'featureGroups',
            linkTo: menuItemToLink['featureGroups'] || undefined,
            text: 'Feature Groups',
            image: images.FeatureGroups
          },
          {
            level: 1,
            name: 'territoryGroups',
            linkTo: menuItemToLink['territoryGroups'] || undefined,
            text: 'Territory Groups',
            image: images.TerritoryGroups,
          },
          {
            level: 1,
            name: 'datazones',
            linkTo: menuItemToLink['none'] || undefined,
            text: 'Data Zones',
            image: images.DataZones,
            subMenus: [
              {
                level: 2,
                name: 'commercialZones',
                linkTo: menuItemToLink['commercialZones'] || undefined,
                text: 'Commercial Zones',
                image: images.CommercialZones
              },
              {
                level: 2,
                name: 'geoZones',
                linkTo: menuItemToLink['geoZones'] || undefined,
                text: 'Geo Zones',
                image: images.GeoZones
              }
            ]
          }
        ]
      }
    ]
  },
  {
    name: 'eventManagement',
    title: 'Event Management',
    menus: [
      {
        level: 0,
        name: 'approvals',
        linkTo: menuItemToLink['approvals'] || undefined,
        text: 'Approvals',
        image: images.Approvals
      },
      {
        level: 0,
        name: 'alerts',
        linkTo: menuItemToLink['alerts'] || undefined,
        text: 'Alerts',
        image: images.Alerts
      },
      {
        level: 0,
        name: 'notifications',
        linkTo: menuItemToLink['notifications'] || undefined,
        text: 'Notifications',
        image: images.Notifications
      },
      {
        level: 0,
        name: 'heatMaps',
        linkTo: menuItemToLink['heatMaps'] || undefined,
        text: 'Heatmaps',
        image: images.Heatmaps
      }
    ]
  },
  {
    name: 'systemReporting',
    title: 'System Reporting',
    menus: [
      {
        level: 0,
        name: 'userActivity',
        linkTo: menuItemToLink['userActivity'] || undefined,
        text: 'User Activity',
        image: images.UserActivity
      },
      {
        level: 0,
        name: 'auditLog',
        linkTo: menuItemToLink['auditLog'] || undefined,
        text: 'Audit Log',
        image: images.AuditLog
      }
    ]
  },
  {
    name: 'dataManagement',
    title: 'Data Management',
    menus: [
      {
        level: 0,
        name: 'refrenceData',
        linkTo: menuItemToLink['refrenceData'] || undefined,
        text: 'Reference Data',
        image: images.refrenceData
      },
      {
        level: 0,
        name: 'import',
        linkTo: menuItemToLink['import'] || undefined,
        text: 'Import',
        image: images.Import
      },
      {
        level: 0,
        name: 'export',
        linkTo: menuItemToLink['export'] || undefined,
        text: 'Export',
        image: images.Export
      },
      {
        level: 0,
        name: 'adaptersIntegrations',
        linkTo: menuItemToLink['adaptersIntegrations'] || undefined,
        text: "Adapters & Integrations",
        image: images.Adapters
      }
    ]
  },
  {
    name: 'settings',
    title: 'Settings',
    menus: [
      {
        level: 0,
        name: 'themes',
        linkTo: menuItemToLink['themes'] || undefined,
        text: 'Themes',
        image: images.Themes
      },
      {
        level: 0,
        name: 'templates',
        linkTo: menuItemToLink['templates'] || undefined,
        text: 'Templates',
        image: images.Templates
      },
      {
        level: 0,
        name: 'dashboards',
        linkTo: menuItemToLink['dashboards'] || undefined,
        text: 'Dashboards',
        image: images.Dashboards
      },
      {
        level: 0,
        name: 'historicalData',
        linkTo: menuItemToLink['historicalData'] || undefined,
        text: 'Historical Data',
        image: images.HistoricalData
      },
      {
        level: 0,
        name: 'mapMarkers',
        linkTo: menuItemToLink['mapMarkers'] || undefined,
        text: 'Map Markers',
        image: images.MapMarkers
      },
      {
        level: 0,
        name: 'tempDyn',
        linkTo: menuItemToLink['tempDyn'] || undefined,
        text: 'Layouts',
        image: images.DataFieldManagement
      },
      {
        level: 0,
        name: 'fieldmngr',
        linkTo: menuItemToLink['fieldmngr'] || undefined,
        text: 'Field Management',
        image: images.DataFieldManagement
      },
      {
        level: 0,
        name: 'imageManagement',
        linkTo: menuItemToLink['imageManagement'] || undefined,
        text: 'Image Management',
        image: images.ImageManagement
      }
    ]
  }
]
